import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useReportWorkplaceState } from './Reports';

type ReportAddButtonProps = {
    showModal: () => void;
};

const ReportAddButton = ({ showModal }: ReportAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useReportWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default ReportAddButton;
